/* global DG */

export class generateMarkers {
  constructor(data, mapSelector, center = [50.4548466, 30.5614487], zoom = 11) {
    this.loadScript();

    this.markers = [];
    this.data = data;
    this.zoom = zoom;
    this.center = center;
    this.mapSelector = mapSelector;

    setTimeout(() => {
      this.initMap();
    }, 1000);

  }

  loadScript() {
    const script = document.createElement('script');
    script.src = `//maps.api.2gis.ru/2.0/loader.js?pkg=full`;
    script.async = true;

    document.body.appendChild(script);
  }

  initMap() {
    window.DG.then(() => {
      this.map = DG.map(this.mapSelector, {
        center: this.center,
        zoom: this.zoom,
        touchZoom: true
      });
      this.setMarker(this.data);
    });
  }

  setMarker(markerData) {

    let content = this.creatPopup(markerData);
    this.markers = window.DG.marker([markerData.lat, markerData.lng], {
      label: markerData.address,
    }).addTo(this.map).bindPopup(content);
  }

  creatPopup(info) {
    let popup = '<div style="padding:16px 0 0;">';

    if ( info.title ) {
      popup += `<div style="font-weight:bold;white-space: nowrap;">${info.title}</div>`;
    }

    if ( info.address ) {
      popup += `<div>${info.address}</div>`;
    }

    popup += '</div>';

    return popup;
  }
}
